export class EnrollmentList {
  static readonly type = '[EnrollmentList] Post';
  constructor(public param: { list_for: number; type: string }) {}
}
